export default {
    userSubscription: 'loadUserSubscription',
    currentSubscription: 'loadUserSubscription',
    profileControls: 'loadProfileControls',
    licenses: 'loadLicenses',
    products: 'loadProducts',
    invoices: 'loadInvoices',
    upcomingInvoice: 'loadUpcomingInvoice',
};
